var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card",staticStyle:{"min-height":"100vh"}},[_c('CustomDomain')],1)])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }